<template>
  <ValidationObserver
    ref="observer"
    v-slot="{ valid, dirty }"
  >
    <NavTabs
      customClass="capitalize_title"
      :tabs="tabs"
      :activeTab="newActiveTab"
      @sendData="updateData"
    />

    <SlotScopeWatcher
      :value="dirty"
      @change="$emit('dirtyChanged', dirty)"
    />
    <SlotScopeWatcher
      :value="valid"
      @change="$emit('validChanged', valid)"
    />
  </ValidationObserver>
</template>

<script>
import Vue from 'vue';
import { mapGetters } from 'vuex';
import { ValidationObserver } from 'vee-validate';
import SlotScopeWatcher from '@/components/shared/widgets/forms/validationHelper/SlotScopeWatcher';
import NavTabs from '@/components/shared/widgets/Nav-tabs.vue';
import Controller from '@/components/forms/treatmentProgram/forms/steam/Controller';
import Function from '@/components/forms/treatmentProgram/forms/steam/Function';
import InjectionControl from '@/components/forms/treatmentProgram/forms/steam/InjectionControl';
import InjectionPoint from '@/components/forms/treatmentProgram/forms/steam/InjectionPoint';
import Product from '@/components/forms/treatmentProgram/forms/steam/Product';
import TargetDosage from '@/components/forms/treatmentProgram/forms/steam/TargetDosage';
import ProgramControl from '@/components/forms/treatmentProgram/forms/steam/ProgramControl';
import History from '@/components/shared/history.vue';

export default {
    components: {
        ValidationObserver,
        SlotScopeWatcher,
        NavTabs,
    },
    props: {
        network: {
            type: Object,
            default: null,
        },
        nodeInfo: {
            type: Object,
            default: null,
        },
        isEdition: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            loading: false,
            tabs: [],
            components: [Product, Function, InjectionPoint, InjectionControl, TargetDosage, ProgramControl, Controller],
            empty: {
                siteProduct: {},
                function: {
                    oxygenScavenger: undefined,
                    fouling: undefined,
                    scaling: undefined,
                    corrosion: undefined,
                    microbiological: undefined,
                    other: undefined,
                    otherText: '',
                },
                injectionPoint: {
                    deaerator: undefined,
                    hotwell: undefined,
                    boiler: undefined,
                    steam: undefined,
                    other: undefined,
                    otherText: '',
                },
                injectionControl: {
                    injection: undefined,
                    schedule: {
                        cycleType: undefined,
                        durationOfInjection: {
                            day: undefined,
                            startHour: '',
                            duration: {
                                hour: '',
                                min: '',
                                sec: '',
                            },
                        },
                        prebleed: {
                            active: false,
                            value: '',
                            unit: undefined,
                        },
                        blowdownLockOut: {
                            active: false,
                            value: '',
                            unit: undefined,
                        },
                    },
                    probeDriven: {
                        type: undefined,
                        otherText: '',
                    },
                    manual: '',
                    time: '',
                    DilutionInDayTank: false,
                    other: '',
                },
                targetDosage: {
                    ppm: '',
                    pumpModel: '',
                    maximumPumpPressure: {
                        value: '',
                        unit: undefined,
                    },
                    maximumPumpRating: {
                        value: '',
                        unit: undefined,
                    },
                    realFlowRate: {
                        value: '',
                        unit: undefined,
                    },
                },
                programControl: {
                    steamMeter: undefined,
                    steamMeterConnectToController: undefined,
                    makeupWaterMeter: undefined,
                    makeupWaterMeterConnectToController: undefined,
                    blowdownWaterMeter: undefined,
                    blowdownWaterMeterConnectToController: undefined,
                    condensateMeter: undefined,
                    condensateMeterConnectToController: undefined,
                },
                controller: {
                    brand: '',
                    model: '',
                    functionalities: {
                        type: undefined,
                        otherText: '',
                    },
                },
            },
        };
    },
    computed: {
        ...mapGetters([
            'activeTab',
        ]),
        newActiveTab: {
            get() {
                return this.activeTab;
            },
            set(newValue) {
                this.$store.dispatch('changeActiveTab', newValue);
            },
        },
    },
    async created() {
        this.loading = true;
        this.$store.dispatch('changeActiveTab', 0);

        this.model = this.isEdition ? this.nodeInfo : this.empty;
        if (this.model.history && this.model.history.length) {
            // insert in last position
            this.components.splice(this.components.length, 0, History);
        }
        this.tabs = this.tableHeaders();
        this.loading = false;
    },
    methods: {
        tableHeaders() {
            const headers = this.components.map((component, index) => ({
                index,
                props: this.model,
                name: this.$t(`treatmentProgram.steam.step${index}.title`),
                component: Vue.component(`tab-${index}`, component),
            }));
            this.$store.dispatch('setTabs', headers);
            return headers;
        },
        updateData(newData) {
            this.model = { ...this.model, ...newData };
            this.$emit('sendData', this.model);
        },
    },
};
</script>
